import { IDocumentAlert } from "../IDocumentAlert";
import { IItem } from "../items";

export class InitialAlert implements IDocumentAlert {
  constructor(private _source: IDocumentAlert) {
  }

  get detectedItem(): IItem {
    return this._source.detectedItem;
  }

  get kind(): string {
    return this._source.kind;
  }

  get target(): string {
    return this._source.target;
  }

  get description(): string {
    return this._source.description;
  }

  get isError(): boolean {
    return this._source.isError;
  }

  get itemSetId(): number {
    return this._source.itemSetId;
  }

  get isConfirmDenied(): boolean {
    return this._source.isConfirmDenied;
  }

  set isConfirmDenied(value: boolean) {
    this._source.isConfirmDenied = value;
  }
}
